import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import {
  skeletonLoaderHeight,
  skeletonLoaderWidth
} from '@/constants/constants-components';

@Component({})
class EdSkeletonLoader extends Vue {
  @Prop({ type: Boolean, default: true }) readonly loading!: boolean;
  @Prop({ type: Number, default: 100 }) readonly width!: number;
  @Prop({ type: Number, default: null }) readonly height!: number | null;
  @Prop({ type: Number, default: 1 }) readonly rounded!: number;
  @Prop({ type: Boolean, default: false }) readonly isCircle!: boolean;
  @Prop({ type: Boolean, default: false }) readonly isFixedWidth!: boolean;

  get computedStyles() {
    const height = this.height ?? 12;
    const width = this.isCircle
      ? `${height}px`
      : `${this.width}${this.isFixedWidth ? 'px' : '%'}`;

    return {
      [skeletonLoaderWidth]: `${width}`,
      [skeletonLoaderHeight]: `${height}px`
    };
  }

  get addSkeletonClass() {
    return {
      [`rounded-${this.rounded}`]: !!this.rounded,
      'ed-skeleton-loader-border-radius': this.isCircle
    };
  }
}

export default Vue.component('ed-skeleton-loader', EdSkeletonLoader);
